// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar_menuBar__6VJeM","logo":"MenuBar_logo__3g_GX","right":"MenuBar_right__332IX","actions":"MenuBar_actions__eGO3G"};